export default __webpack_public_path__ + "static/vdotted2-bee39512ed21a3945f48f4ddcb17a0f0.svg";